// extracted by mini-css-extract-plugin
export var cdArrow = "mobilemenu-module--cd-arrow--5f60a";
export var cdMobileMenu = "mobilemenu-module--cd-mobile-menu--7ee0f";
export var cdMobileMenuClose = "mobilemenu-module--cd-mobile-menu-close--a4d5e";
export var cdMobileMenuCollage = "mobilemenu-module--cd-mobile-menu-collage--841f4";
export var cdMobileMenuContent = "mobilemenu-module--cd-mobile-menu-content--b4196";
export var cdMobileMenuFooter = "mobilemenu-module--cd-mobile-menu-footer--9c537";
export var cdMobileMenuFooterItem = "mobilemenu-module--cd-mobile-menu-footer-item--3d7d9";
export var cdMobileMenuFooterLinks = "mobilemenu-module--cd-mobile-menu-footer-links--47128";
export var cdMobileMenuHeader = "mobilemenu-module--cd-mobile-menu-header--78ba9";
export var cdMobileMenuHeaderItem = "mobilemenu-module--cd-mobile-menu-header-item--52fe8";
export var cdMobileMenuLinks = "mobilemenu-module--cd-mobile-menu-links--29d7f";
export var cdMobileMenuOverlay = "mobilemenu-module--cd-mobile-menu-overlay--1e044";
export var cdMobileMenuProductImg = "mobilemenu-module--cd-mobile-menu-product-img--e3592";
export var cdMobileMenuProducts = "mobilemenu-module--cd-mobile-menu-products--0b243";
export var cdMobileMenuProductsHeading = "mobilemenu-module--cd-mobile-menu-products-heading--d9090";
export var cdMobileMenuProductsItem = "mobilemenu-module--cd-mobile-menu-products-item--754f7";
export var cdMobileMenuProductsLastLink = "mobilemenu-module--cd-mobile-menu-products-last-link--a1b2a";
export var cdMobileMenuProductsOpen = "mobilemenu-module--cd-mobile-menu-products-open--390b3";
export var cdMobileMenuWrapper = "mobilemenu-module--cd-mobile-menu-wrapper--fcbde";
export var fromLeft = "mobilemenu-module--fromLeft--91413";
export var fromRight = "mobilemenu-module--fromRight--c9f7d";
export var isOpen = "mobilemenu-module--isOpen--a5da7";